@if(isParent()){
<tr class="table-light">
  <td class="text-center small fw-bold">{{indexLabel}}</td>
  <td colspan="4">
    <div class="d-flex justify-content-between align-items-center">
      <span class="small">{{answer.question.title}}</span>
      <span class="badge" [ngClass]="subPct()===100 ? 'bg-success' : subPct()>0 ? 'bg-warning text-dark' : 'bg-light text-dark border'">{{subPct()}}%</span>
    </div>
  </td>
</tr>
@for(sub of answer.subitems; track sub.question.id; let j = $index){
<tr>
  <td class="text-center small">{{indexLabel}}.{{j+1}}</td>
  <td>
    <div class="d-flex align-items-start gap-2">
      <span class="small flex-grow-1">{{sub.question.title}}</span>
      @if(isGoalComplete(sub.question)){<span class="badge bg-success ms-1">Meta cumplida</span>}
      @if(sub.question.tooltip){<button class="btn btn-xs btn-ghost ms-1" triggers="hover" [ngbTooltip]="sub.question.tooltip"><i class="fas fa-circle-question"></i></button>}
    </div>
  </td>
  <td>
    @if(sub.question.questionType?.dataType==='boolean'){
    <select class="form-select form-select-sm" [disabled]="isSubLocked(sub)" [(ngModel)]="sub.answer" (change)="subAnswerBlur(sub)">
      <option [ngValue]="null">Seleccione...</option>
      <option value="true">Sí</option>
      <option value="false">No</option>
    </select>
    } @else if(sub.question.questionType?.dataType==='number'){
    <input type="text" inputmode="numeric" class="form-control form-control-sm" [class.is-invalid]="subInvalid[sub.id]" [pattern]="subRegex(sub) || ''" [(ngModel)]="sub.answer" [disabled]="isSubLocked(sub)" (blur)="subAnswerBlur(sub)" placeholder="Valor">
    @if(subInvalid[sub.id]){<small class="text-danger">Formato no válido</small>}
    } @else if(sub.question.questionType?.dataType==='date'){
    <input type="date" class="form-control form-control-sm" [(ngModel)]="sub.answer" [disabled]="isSubLocked(sub)" (blur)="subAnswerBlur(sub)">
    } @else if(sub.question.questionType?.dataType==='file'){
    <input type="file" class="form-control form-control-sm" [disabled]="isSubLocked(sub)" (change)="onSubFileChange($event, sub)">
    } @else {
    <input type="text" class="form-control form-control-sm" [(ngModel)]="sub.answer" [disabled]="isSubLocked(sub)" (blur)="subAnswerBlur(sub)" placeholder="Respuesta">
    }
  </td>
  <td class="text-center">
    @if(evidenceTypeForSub(sub); as ev){
      <div class="d-flex justify-content-center gap-1">
        <button class="btn btn-sm btn-outline-secondary" [disabled]="!hasEvidence(sub)" (click)="viewEvidence(sub)" title="Ver evidencia"><i class="fas fa-eye"></i></button>
        <button class="btn btn-sm btn-outline-primary" [disabled]="isSubLocked(sub)" (click)="openEvidenceModal(sub, indexLabel + '.' + (j+1))" title="Adjuntar evidencia"><i class="fas fa-paperclip"></i></button>
        @if(reviewMode){
        <button class="btn btn-sm btn-outline-warning" (click)="openReviewModal(sub)" title="Motivo de revisión"><i class="fas fa-comment-dots"></i></button>
        }
      </div>
      @if(canSeeReview(sub)){
      <div class="mt-1 p-1 border rounded bg-light text-start">
        <small class="fw-bold text-warning">Auditor:</small>
        <small class="d-block">{{reviewText(sub)}}</small>
      </div>
      }
    } @else {<span class="text-muted">—</span>}
  </td>
  <td>
    <div class="d-flex align-items-center gap-2">
      <div class="progress flex-grow-1" style="height: 8px; background: #e9ecef;"><div class="progress-bar" [class.bg-secondary]="subProgressValue(sub)===0" [class.bg-warning]="subProgressValue(sub)===50" [class.bg-success]="subProgressValue(sub)===100" [style.width.%]="subProgressValue(sub)"></div></div>
      <small class="text-muted" style="min-width:28px">{{subProgressValue(sub)}}%</small>
    </div>
  </td>
</tr>
}
} @else {
<tr>
  <td class="text-center small">{{indexLabel}}</td>
  <td>
    <div class="d-flex align-items-start gap-2">
      <span class="small flex-grow-1">{{answer.question.title}}</span>
      @if(isGoalComplete(answer.question)){<span class="badge bg-success ms-1">Meta cumplida</span>}
      @if(answer.question.tooltip){<button class="btn btn-xs btn-ghost ms-1" triggers="hover" [ngbTooltip]="answer.question.tooltip"><i class="fas fa-circle-question"></i></button>}
    </div>
  </td>
  <td>
    @if(dataType()==='boolean'){
    <select class="form-select form-select-sm" [disabled]="isAnswerLocked()" [(ngModel)]="answer.answer" (change)="onAnswerBlur()">
      <option [ngValue]="null">Seleccione...</option>
      <option value="true">Sí</option>
      <option value="false">No</option>
    </select>
    } @else if(dataType()==='number'){
    <input type="text" inputmode="numeric" class="form-control form-control-sm" [class.is-invalid]="invalid" [pattern]="regexToUse() || ''" [(ngModel)]="answer.answer" [disabled]="isAnswerLocked()" (blur)="onAnswerBlur()" placeholder="Valor">
    @if(invalid){<small class="text-danger">Formato no válido</small>}
    } @else if(dataType()==='date'){
    <input type="date" class="form-control form-control-sm" [(ngModel)]="answer.answer" [disabled]="isAnswerLocked()" (blur)="onAnswerBlur()">
    } @else if(dataType()==='file'){
    <input type="file" class="form-control form-control-sm" [disabled]="isAnswerLocked() || uploading" (change)="onFileChange($event)">
    @if(uploading){<span class="spinner-border spinner-border-sm ms-1"></span>}
    } @else {
    <input type="text" class="form-control form-control-sm" [(ngModel)]="answer.answer" [disabled]="isAnswerLocked()" (blur)="onAnswerBlur()" placeholder="Respuesta">
    }
  </td>
  <td class="text-center">
    @if(evidenceType(); as ev){
      <div class="d-flex justify-content-center gap-1">
        <button class="btn btn-sm btn-outline-secondary" [disabled]="!hasEvidence(answer)" (click)="viewEvidence(answer)" title="Ver evidencia"><i class="fas fa-eye"></i></button>
        <button class="btn btn-sm btn-outline-primary" [disabled]="isAnswerLocked()" (click)="openEvidenceModal(answer, indexLabel)" title="Adjuntar evidencia"><i class="fas fa-paperclip"></i></button>
        @if(reviewMode){
        <button class="btn btn-sm btn-outline-warning" (click)="openReviewModal(answer)" title="Motivo de revisión"><i class="fas fa-comment-dots"></i></button>
        }
      </div>
      @if(canSeeReview(answer)){
      <div class="mt-1 p-1 border rounded bg-light text-start">
        <small class="fw-bold text-warning">Auditor:</small>
        <small class="d-block">{{reviewText(answer)}}</small>
      </div>
      }
    } @else {<span class="text-muted">—</span>}
  </td>
  <td>
    <div class="d-flex align-items-center gap-2">
      <div class="progress flex-grow-1" style="height: 8px; background: #e9ecef;"><div class="progress-bar" [class.bg-secondary]="rowProgress()===0" [class.bg-warning]="rowProgress()===50" [class.bg-success]="rowProgress()===100" [style.width.%]="rowProgress()"></div></div>
      <small class="text-muted" style="min-width:28px">{{rowProgress()}}%</small>
    </div>
  </td>
</tr>
}
